var map = {
	"./partner10.jpg": "4d66",
	"./partner11.jpg": "0f31",
	"./partner12.png": "c1a5",
	"./partner13.png": "093e",
	"./partner14.png": "ae18",
	"./partner15.jpg": "6f2c",
	"./partner16.jpg": "c350",
	"./partner17.jpg": "b57e",
	"./partner18.jpg": "ef4a",
	"./partner3.png": "d87c",
	"./partner4.png": "7bbe",
	"./partner4.svg": "9096",
	"./partner5.jpg": "7b36",
	"./partner6.png": "d718d",
	"./partner7.png": "d8c3",
	"./partner8.png": "6896",
	"./partner9.jpg": "41e5",
	"./partner9_arm.jpg": "a91c",
	"./partner9_ru.jpg": "49f2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "78ea";